module.exports = __webpack_public_path__ + "media/images/lp_modal-image_school-231f5aa8094fbadf658b64d66e2743af.webp";